import AvatarPlaceholder from 'src/assets/images/avatar_placeholder.svg';
import { AvatarImage, AvatarRoot } from '../../styles/Atoms.styles';
import type { UserAvatarProps } from '../../types/dashboard';

/**
 * Deterministic fallback tint so the same person keeps the same colour across
 * the leaderboard, the activity feed and the peer strip.
 */
const FALLBACK_TINTS = ['#2F74D0', '#8B5CF6', '#46C93A', '#FF9F1C', '#FF5D5D'];

const tintFor = (seed: string): string => {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) % 100_000;
  }
  return FALLBACK_TINTS[hash % FALLBACK_TINTS.length];
};

const UserAvatar = ({
  name,
  picture,
  size = 32,
  color,
  className,
}: UserAvatarProps) => {
  const label = name?.trim() || '?';
  return (
    <AvatarRoot size={size} bg={color || tintFor(label)} className={className}>
      {picture ? (
        <AvatarImage
          src={picture}
          alt=""
          aria-hidden
          onError={(e) => {
            const img = e.currentTarget;
            if (img.src !== AvatarPlaceholder) img.src = AvatarPlaceholder;
          }}
        />
      ) : (
        label[0].toUpperCase()
      )}
    </AvatarRoot>
  );
};

export default UserAvatar;
